module.exports = __webpack_public_path__ + "static/img/13.8bd311b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/13.png
// module id = NDga
// module chunks = 0